import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageInvoiceService } from './manage-invoice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { IInvoice, IProjectInvoicesResponse } from './manage-invoice.interfaces';
import { DialogFactures } from '../dialog/factures/dialog.component.factures';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-manage-invoice',
  templateUrl: './manage-invoice.component.html',
  styleUrls: ['./manage-invoice.component.scss']
})
export class ManageInvoiceComponent implements OnInit, OnDestroy {
  private routeParamsSubs: any;
  public userInfo: any = {};
  private invoiceModel: IInvoice = {
      'id': 'NEW',
      'projecte_codi': '',
      'fita': '',
      'objecte_lliurament': '',
      'facturacio_prevista_percent': 0,
      'facturacio_prevista_eur': 0,
      'previsio_cobrament': 0,
      'numero_factura': null,
      'observacions': null,
      'data_factura': null,
      'data_cobrament': null,
      'data_factura_prevista': (new Date()).toISOString().slice(0, 10),
      'data_cobrament_prevista': null,
      'impostos': 0,
      'iva': 0,
      'facturacio_cobrament': 0,
      'facturacio_prevista_loc': 0,
      'moneda_previsio': '',
      'canvi_moneda': 0,
      'pressupost': null,
      'activa': true,
      'facturar': false,
      'clau': ''
  };
  private projectCode: string;
  private unsubscriber : Subject<void> = new Subject<void>();

  public showDialog: boolean = false;
  public showAsyncProgress: boolean = false;
  public invoicingData: IProjectInvoicesResponse;
  public editInvoiceData: IInvoice;
  public esAjustComptable: boolean = true;
  public invoiceTable: string = 'invoice';
  public acumulat = {
    facturat: 0,
    cobrat: 0
  };

  public chgInvoices($event){//$event == null onInit no cal canviar el check
    if($event)this.esAjustComptable = !this.esAjustComptable;
    this.invoiceTable = this.esAjustComptable?'invoice':'invoicetr';
    this.manageInvoiceService.getByProject(this.invoiceTable, this.projectCode)
      .subscribe(
        data => { this.invoicingData = data;},
        error => console.log(error)
      );
  }

  public editInvoice(invoice: IInvoice): void {
    this.editInvoiceData = Object.assign(
      {},
      this.invoiceModel,
      invoice
    );
   this.editInvoiceData.pressupost = this.invoicingData.projectData.pressupostContractat;
   this.editInvoiceData.clau = this.invoicingData.projectData["clau"];
   
   let dialogFactRef=this.dialog.open(DialogFactures, {disableClose: true, data: {fact: this.editInvoiceData, taula:this.invoiceTable} })
   
   dialogFactRef.afterClosed().subscribe(results => {
     if(!results)return;
     this.editInvoiceData = results;
     this.addOrUpdateUser();
   });
  }

  public addInvoice(): void {
    this.editInvoiceData = Object.assign(
      {},
      this.invoiceModel,
      { projecte_codi : this.projectCode }
    );
    this.editInvoiceData.pressupost = this.invoicingData.projectData.pressupostContractat;
    this.editInvoiceData.clau = this.invoicingData.projectData["clau"];

    let dialogFactRef=this.dialog.open(DialogFactures, {data: {fact: this.editInvoiceData, taula:this.invoiceTable} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editInvoiceData = results;
      this.addOrUpdateUser();
    });
  }

  public addOrUpdateUser(/*$event*/): void {
    this.showAsyncProgress = true;
    this.showDialog = false;
    this.editInvoiceData.facturacio_prevista_eur = this.editInvoiceData.facturacio_prevista_loc*this.editInvoiceData.canvi_moneda
    if (this.editInvoiceData.id === 'NEW') {
      this.manageInvoiceService.create(this.invoiceTable, this.editInvoiceData)
        .subscribe(newInvoice => {
          this.invoicingData.invoices = [newInvoice, ...this.invoicingData.invoices];
          this.showAsyncProgress = false;
          this.chgInvoices(null);
        },
          err => console.log(err)
        );
    } else {
      this.manageInvoiceService.update(this.invoiceTable, <number> this.editInvoiceData.id, this.editInvoiceData)
        .subscribe(updatedInvoice => {
          this.invoicingData.invoices = this.invoicingData.invoices.map(invoice => {
            return (invoice.id === updatedInvoice.id ? updatedInvoice : invoice);
          },
          err => console.log(err)
        );
        this.showAsyncProgress = false;
        this.chgInvoices(null);
        });
    }
  }

  public deleteInvoice(invoiceToDelete: IInvoice): void {
    if(confirm("Confirma l'esborrat de la factura")){
      this.showAsyncProgress = true;
      this.showDialog = false;
      this.manageInvoiceService.destroy(this.invoiceTable, <number> invoiceToDelete.id)
        .subscribe(deletedInvoice => {
          this.invoicingData.invoices = this.invoicingData.invoices
           .filter(invoice => invoice.id !== deletedInvoice.id);
          this.showAsyncProgress = false;
          this.chgInvoices(null);
        },
         err => console.log(err)
        );
    }
  }

  public goProject(){ this.router.navigate(['project',this.invoicingData.projectData.codi]);};
  
  public export(){
    var csvData = this.convertToCSV( this.invoicingData.invoices);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData.replace(/,/g,"").replace(/\./g,",")], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    var x:Date = new Date();
    var link:string ="factures_"+this.invoicingData.projectData.codi+"_"+ x.getMonth() +  "_" +  x.getDay() + '.csv';
    a.download = link.toLocaleLowerCase();
    a.click();
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private manageInvoiceService: ManageInvoiceService, private tokenStorage: TokenStorageService, private route: ActivatedRoute, public dialog:MatDialog, private router: Router) { 
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.routeParamsSubs = this.route.params.subscribe(params => {
      this.projectCode = params['id'];
      this.manageInvoiceService.getByProject(this.invoiceTable, this.projectCode)
          .subscribe(
            data => { 
              this.invoicingData = data;
              this.esAjustComptable = this.invoicingData.projectData['num_ftr']?false:true;
              this.esAjustComptable?'':this.chgInvoices(null)},
            error => console.log(error)
          );
    });
  
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
    this.routeParamsSubs.unsubscribe(); 
  }
  
}
